import React from "react";
import { Link } from "react-router-dom";
import { useUsuario } from "../../context/usuario-context";

import "./Inicio.css";
import { Grid } from "@mui/material/";

import ctrivia from "../../assets/images/ctrivia.png";
import ccrucigrama from "../../assets/images/ccrucigrama.png";
import ccrucigramades from "../../assets/images/ccrucigramades.png";
import csopa from "../../assets/images/csopa.png";
import csopades from "../../assets/images/csopades.png";

function Inicio() {
  const { config } = useUsuario();

  return (
    <Grid container className="inicioContainer">
      <Grid item xs={12} md={4}>
        <Link to="/Trivia">
          <img
            src={ctrivia}
            alt="Trivia"
            width="90%"
            height="100%"
            style={{ marginLeft: "2%" }}
          />
        </Link>
      </Grid>
      <Grid item xs={12} md={4}>
        {config.juegosdos ? (
          <Link to="/Crucigrama">
            <img
              src={ccrucigrama}
              alt="Crucigrama"
              width="90%"
              height="100%"
              style={{ marginLeft: "2%" }}
            />
          </Link>
        ) : (
          <img
            src={ccrucigramades}
            alt="Crucigrama"
            width="90%"
            height="100%"
            style={{ marginLeft: "2%" }}
          />
        )}
      </Grid>
      <Grid item xs={12} md={4}>
        {config.juegotres ? (
          <Link to="/SopaDeLetras">
            <img
              src={csopa}
              alt="Trivia"
              width="90%"
              height="100%"
              style={{ marginLeft: "2%" }}
            />
          </Link>
        ) : (
          <img
            src={csopades}
            alt="Trivia"
            width="90%"
            height="100%"
            style={{ marginLeft: "2%" }}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default Inicio;
